import { useState } from "react";
import { Button, Hidden } from "@mui/material";
import { Theme } from "@mui/material/styles";
import { makeStyles } from "@mui/styles";
import {
  IdsExpandMore as ArrowDropDownIcon,
  IdsExpandLess as ArrowDropUpIcon,
} from "components/shared/svgIcons";

import { Menu, MenuItem } from "components/shared";
import { colors } from "theme";
import { ISort } from "types/common";

const useStyles = makeStyles((theme: Theme) => ({
  sortMenu: {
    width: 136,
    "& li": {
      borderBottom: `1px solid ${colors.grey[400]}`,
    },
  },
  sortByButton: {
    height: 32,
    "& .MuiButton-iconSizeSmall > *:first-child": {
      fontSize: theme.typography.pxToRem(24),
    },
    "& .MuiButton-endIcon.MuiButton-iconSizeSmall": {
      marginRight: theme.spacing(-1),
    },
  },
}));

const SortBy = <T extends any>({
  sortBy,
  setSortBy,
  sorts,
}: {
  sorts: ISort<T>[];
  sortBy: ISort<T> | null;
  setSortBy: Function;
}) => {
  const classes = useStyles();
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
  const [buttonActive, setButtonActive] = useState(false);

  const openMenu = (event: React.MouseEvent<HTMLElement>) => {
    setAnchorEl(event.currentTarget);
    setButtonActive(!buttonActive);
  };
  const handleMenuItemClick = (event: React.MouseEvent<HTMLElement>) => {
    setAnchorEl(null);
    setButtonActive(false);
  };
  const handleClose = () => {
    setAnchorEl(null);
    setButtonActive(false);
  };

  return (
    <>
      <Button
        color="primary"
        size="small"
        variant="outlined"
        className={classes.sortByButton}
        endIcon={
          Boolean(anchorEl) ? <ArrowDropUpIcon /> : <ArrowDropDownIcon />
        }
        onClick={openMenu}
      >
        {sortBy ? (
          sortBy.label
        ) : (
          <>
            Sort <Hidden smDown>by</Hidden>
          </>
        )}
      </Button>
      <Menu
        anchorEl={anchorEl}
        open={Boolean(anchorEl)}
        onClose={handleClose}
        onClick={handleMenuItemClick}
        classes={{ paper: classes.sortMenu }}
      >
        {sorts.map((sort: ISort<T>, index: number) => (
          <MenuItem key={index} size="sm" onClick={() => setSortBy(sort)}>
            {sort.label}
          </MenuItem>
        ))}
      </Menu>
    </>
  );
};

export default SortBy;
